import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../styles/pages.css";

function CommunityPage() {
  return (
    <>
      <Navbar />
      <main className="cdh-page cdh-page--reader">
        <div className="cdh-page-hdr">
          <div className="cdh-page-hdr__eyebrow">Community</div>
          <h1 className="cdh-page-hdr__title">What's happening in CAD automation.</h1>
          <p className="cdh-page-hdr__sub">
            Industry news, API trends, student builds, and what companies are actually shipping.
          </p>
        </div>

        <div className="cdh-state">
          Community posts coming soon. Check back shortly.
        </div>
      </main>
      <Footer />
    </>
  );
}

export default CommunityPage;
